<app-loading *ngIf="loading" class="loader"></app-loading>
<div *ngIf="!loading">
  <div class="mt-30 mb-30">
    <div *ngIf="sliderArray && sliderArray.length" class="slider---wrapper">
      <div #sliderRef class="keen-slider keen-slider--vertical">
        <div *ngFor="let idx of sliderArray; let i = index" class="keen-slider__slide">
          <img
            [src]="idx?.link"
            alt=""
            loading="eager"
            (error)="setDefaultImage('home-slider', i)" />
          <div class="overlay">
            <h1>{{ idx.title }}</h1>
            <h3>{{ idx.subTitle }}</h3>
            <h6>{{ idx.content }}</h6>
            <div
              class="slider-button"
              [style.background-color]="idx?.bgColor"
              [style.color]="idx?.labelColor"
              (click)="onShopNowClick(idx?.url)">
              <span> {{ idx?.label }} </span>
            </div>
          </div>
        </div>
      </div>
      <svg
        [ngClass]="'arrow arrow--left ' + (currentSlide === 0 ? 'arrow--disabled' : '')"
        (click)="slider.prev()"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 24 24">
        <path d="M16.67 0l2.83 2.829-9.339 9.175 9.339 9.167-2.83 2.829-12.17-11.996z" />
      </svg>
      <svg
        *ngIf="slider"
        [ngClass]="
          'arrow arrow--right ' +
          (slider?.track.details.slides.length - 1 === currentSlide ? 'arrow--disabled' : '')
        "
        (click)="slider.next()"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 24 24">
        <path d="M5 3l3.057-3 11.943 12-11.943 12-3.057-3 9-9z" />
      </svg>
    </div>
    <div *ngIf="sliderArray && sliderArray.length" class="dots">
      <button
        (click)="slider.moveToIdx(i)"
        *ngFor="let slide of dotHelper; let i = index"
        [class]="'dot ' + (i === currentSlide ? 'active' : '')"></button>
    </div>
    <div *ngIf="categoriesArray && categoriesArray.length" class="category--container">
      <h3>Categories</h3>
      <div class="category-section">
        <div class="scroller">
          <div
            class="category-card"
            (click)="onClickCategories(idx)"
            *ngFor="let idx of categoriesArray; let i = index">
            <div class="category-image-container">
              <img
                [src]="idx.image.linkMd"
                class="category-image"
                loading="lazy"
                (error)="setDefaultImage('category', i)" />
            </div>
            <p class="category-name">{{ idx.categoryName }}</p>
          </div>
        </div>
      </div>
    </div>

    <div
      *ngIf="topSellingSliderArray && topSellingSliderArray.length"
      class="top--selling--container">
      <h3>Top Selling Products</h3>
      <div class="top-selling--slider---wrapper">
        <div #topSellingSliderRef class="keen-slider keen-slider--vertical">
          <div
            [routerLink]="['/product/', idx?._id]"
            *ngFor="let idx of topSellingSliderArray; let i = index"
            class="keen-slider__slide">
            <img
              [src]="idx?.linkMd"
              alt=""
              loading="eager"
              (error)="setDefaultImage('top-selling', i)" />
            <p class="product-name">{{ idx.productName }}</p>
          </div>
        </div>
        <svg
          [ngClass]="'arrow arrow--left ' + (topSellingCurrentSlide === 0 ? 'arrow--disabled' : '')"
          (click)="topSellingSlider.prev()"
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 24 24">
          <path d="M16.67 0l2.83 2.829-9.339 9.175 9.339 9.167-2.83 2.829-12.17-11.996z" />
        </svg>
        <svg
          *ngIf="topSellingSlider"
          [ngClass]="
            'arrow arrow--right ' +
            (topSellingSlider?.track.details.slides.length - 1 === topSellingCurrentSlide
              ? 'arrow--disabled'
              : '')
          "
          (click)="topSellingSlider.next()"
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 24 24">
          <path d="M5 3l3.057-3 11.943 12-11.943 12-3.057-3 9-9z" />
        </svg>
      </div>
    </div>
  </div>
  <!-- <swiper
    [slidesPerView]="1.2"
    [spaceBetween]="20"
    [centeredSlides]="true"
    [loop]="true"
    [navigation]="true"
    class="mySwiper">
    <ng-template swiperSlide>
      <div class="slide-content">Slide 1 Content</div>
    </ng-template>
    <ng-template swiperSlide>
      <div class="slide-content">Slide 2 Content</div>
    </ng-template>
    <ng-template swiperSlide>
      <div class="slide-content">Slide 3 Content</div>
    </ng-template>
  </swiper> -->
</div>
